import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5fc04c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "user__photo" }
const _hoisted_5 = { class: "user__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_skeleton, {
            class: "fullsize",
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, { variant: "circle" })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_skeleton, {
            class: "fullsize",
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, { variant: "text" }),
              _createVNode(_component_el_skeleton_item, { variant: "text" })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}